module.exports = __webpack_public_path__ + "img/icon_youtube.1d5615ab.png";